import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import PropTypes from "prop-types";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ColorPic from "components/Common/ColorPic";

export default function Notes(props) {
  const { onChangeTextEditor, content, label } = props;
  const contentBlock = htmlToDraft(content || "");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (!contentBlock) {
      return;
    }
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    const editorState = EditorState.createWithContent(contentState);
    setEditorState(editorState);
  }, []);

  const onEditorStateChange = editorState => {
    setEditorState(editorState);
    onChangeTextEditor(prev =>
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    );
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Label className="form-label">{label}</Label>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
            editorStyle={{ height: 500 }}
            // toolbar={{
            //   colorPicker: { component: ColorPic },
            // }}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
}

Notes.propTypes = {
  label: PropTypes.any,
  onChangeTextEditor: PropTypes.func,
  content: PropTypes.any,
};
